import React, { useMemo } from 'react'
import {
  GROUP_STAGE_NAMES,
  formatTeamDisplayName,
  getTeamFlagUrl,
  groupStageLabel,
  isPlayoffTeam,
} from './worldCupTeamFlags'

function TeamFlag({ name, flagCode }) {
  const flagUrl = getTeamFlagUrl(name, flagCode)
  if (flagUrl) {
    return <img className="worldcup-team-flag-img" src={flagUrl} alt="" loading="lazy" />
  }
  if (isPlayoffTeam(name)) {
    return (
      <span className="worldcup-team-flag-playoff" aria-hidden="true">
        <svg viewBox="0 0 32 24" xmlns="http://www.w3.org/2000/svg">
          <rect width="32" height="24" fill="#003087" />
          <text x="16" y="15" textAnchor="middle" fill="#fff" fontSize="7" fontWeight="700" fontFamily="Arial, sans-serif">
            FIFA
          </text>
        </svg>
      </span>
    )
  }
  return <span className="worldcup-team-flag-empty" aria-hidden="true" />
}

function TeamRow({ name, flagCode }) {
  return (
    <div className="worldcup-team-row">
      <div className="worldcup-team-flag">
        <TeamFlag name={name} flagCode={flagCode} />
      </div>
      <div className="worldcup-team-name-bar">{formatTeamDisplayName(name)}</div>
    </div>
  )
}

export default function WorldCupGroupsView({ teams = [] }) {
  const teamsByGroup = useMemo(() => {
    const byGroup = Object.fromEntries(GROUP_STAGE_NAMES.map((g) => [g, []]))
    teams.forEach((team) => {
      if (team?.group && byGroup[team.group]) {
        byGroup[team.group].push(team)
      }
    })
    return byGroup
  }, [teams])

  const hasAnyTeams = teams.length > 0

  return (
    <section className="worldcup-teams-stage" aria-label="VM 2026 gruppespil">
      {!hasAnyTeams ? (
        <div className="worldcup-teams-empty">Holdene er endnu ikke offentliggjort.</div>
      ) : (
        <div className="worldcup-groups-grid">
          {GROUP_STAGE_NAMES.map((groupName) => {
            const groupTeams = teamsByGroup[groupName]
            if (groupTeams.length === 0) return null
            return (
              <div key={groupName} className="worldcup-group-block">
                <h2 className="worldcup-group-title">{groupStageLabel(groupName)}</h2>
                <div className="worldcup-group-teams">
                  {groupTeams.map((team) => (
                    <TeamRow key={`${groupName}-${team.name}`} name={team.name} flagCode={team.flagCode} />
                  ))}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </section>
  )
}
